import { AgeYears } from '../value-objects/AgeYears';
import { MoneyAmount } from '../value-objects/MoneyAmount';
import { YearResult } from './YearResult';

export interface MethodResultInit {
  fireNumber: number;
  requiredMonthlyInvestment: number;
  futureNominalValue: number;
  solvedRetirementAge?: AgeYears | null;
  yearResults?: readonly YearResult[];
}

export class MethodResult {
  readonly fireNumber: MoneyAmount;
  readonly requiredMonthlyInvestment: MoneyAmount;
  readonly futureNominalValue: MoneyAmount;
  readonly solvedRetirementAge: AgeYears | null;
  readonly yearResults: readonly YearResult[];

  constructor(init: MethodResultInit) {
    this.fireNumber = new MoneyAmount(init.fireNumber);
    this.requiredMonthlyInvestment = new MoneyAmount(
      init.requiredMonthlyInvestment,
    );
    this.futureNominalValue = new MoneyAmount(init.futureNominalValue);
    this.solvedRetirementAge = init.solvedRetirementAge ?? null;
    this.yearResults = init.yearResults ?? [];
  }

  equals(other: MethodResult): boolean {
    return (
      this.fireNumber.equals(other.fireNumber) &&
      this.requiredMonthlyInvestment.equals(other.requiredMonthlyInvestment) &&
      this.futureNominalValue.equals(other.futureNominalValue) &&
      (this.solvedRetirementAge?.value ?? null) ===
        (other.solvedRetirementAge?.value ?? null)
    );
  }
}